import { Injectable, inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ErrorMessages } from "../constants";

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  private toastr = inject(ToastrService);

  handleError(error: any, config?: { callback?: (errorMessage: string, errorCode: string) => void, showToast?: boolean }): void {
    if (error.name === 'EmptyError') {
      return;
    }

    console.error(error);
    config = config ?? { showToast: true };
    const code = error?.error?.errorCode;
    const message = ErrorMessages[code] || ErrorMessages['errors/default'];

    if (config.showToast) {
      this.toastr.error(message);
    }

    if (config.callback) {
      config.callback(message, code);
    }
  }
}